<template>
    <!-- Used on the overlage pages for the user to click on and dismiss the page -->
	<div class="overlay-btn">
        <div class="d-flex h-100">
            <h1 class="my-auto mx-auto">{{ text }}</h1>
        </div>
    </div>
</template>

<script>
export default {
	name: "OverlayButton",
    props:  {
        text: String
    }
};
</script>

<style scoped>
.overlay-btn {
    border-top-left-radius: 50px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 250px;
	height: 164px;
    width: 339px;
    margin: auto;
    background: white;
    z-index: var(--global-z-index-overlay-info);
}

.overlay-btn h1 {
    font-size: 100px;
}
</style>